import React from "react";
import { Pad } from "../../../../../components";
import {
  WatchlistItemContainer,
  WatchlistItemSubContainer,
  WatchlistTrackerContainer,
} from "../../practiceGuide/styled";
import { CustomRadio } from "../CustomRadio";

export function PredefinedWatchlists({ data, selected, onSelect }) {
  return (
    <>
      {data
        ? data.map((el) => (
            <>
              <WatchlistItemContainer onClick={() => onSelect(el.id)}>
                <CustomRadio active={selected.includes(el.id)} />
                <WatchlistItemSubContainer>
                  <div style={{ fontWeight: "bold" }}>{el.name}</div>
                  <div>{el.description}</div>
                  {selected.includes(el.id)
                    ? el.trackers.map((trc) => (
                        <>
                          <Pad height="10px" />
                          <WatchlistTrackerContainer>
                            {/* <div>icon</div> */}
                            <Pad width="10px" />
                            <div>
                              <div style={{ fontSize: "16px" }}>
                                {trc.trackerId}
                              </div>
                              <div style={{ fontSize: "12px" }}>
                                Range {trc.rangeMin} to {trc.rangeMax}
                              </div>
                            </div>
                          </WatchlistTrackerContainer>
                        </>
                      ))
                    : ""}
                </WatchlistItemSubContainer>
              </WatchlistItemContainer>
              <Pad height="10px" />
            </>
          ))
        : ""}
    </>
  );
}
